import React from 'react';
import Cookies from 'universal-cookie';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware/*, compose*/ } from 'redux';
import { Provider } from 'react-redux';
import createSagaMiddleware from 'redux-saga';

import './index.css';
import Project from './components/Project';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

import rootReducer from './reducers'
import rootSaga from './sagas'

import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';

//const worker = new Worker("worker.js");
const composeEnhancers = composeWithDevTools({
    // options like actionSanitizer, stateSanitizer
    trace: true, traceLimit: 25
});
const sagaMiddleware = createSagaMiddleware();
let enhancers = composeEnhancers(
    applyMiddleware(sagaMiddleware)
    // other store enhancers if any
);
//import * as Sentry from "@sentry/react";
//import { BrowserTracing } from "@sentry/tracing";
//import { CaptureConsole as CaptureConsoleIntegration, ExtraErrorData } from "@sentry/integrations";
if(/*window.self === window.top && */process.env.REACT_APP_SENTRY_URL && `${process.env.REACT_APP_SENTRY_URL}`!=='undefined' && `${process.env.REACT_APP_SENTRY_URL}`!=='' && `${process.env.MIX_SENTRY_DSN}` !== '' && !/Daum|Headless|baiduboxapp| BW\/\d+\.\d+| PTST\/\d+\.\d+/.test(navigator.userAgent)) {
    let Sentry = require("@sentry/react");
    //let {BrowserTracing} = require("@sentry/tracing");
    let {CaptureConsole: CaptureConsoleIntegration, ExtraErrorData} = require("@sentry/integrations");

    let logs = [/*'info', */'warn', 'error']; // , 'debug'
    if (`${process.env.REACT_APP_STAGE}` === "production") {
        logs = ['warn', 'error', 'debug'];
    }
    Sentry.init({
        release: 'joindesignapp'+`${process.env.REACT_APP_BRANCHNAME}`,
        environment: `${process.env.REACT_APP_STAGE}`,
        dsn: `${process.env.REACT_APP_SENTRY_URL}`,
        ignoreErrors: [
            // 'undefined',
            /_AutofillCallbackHandler/,
            /ReferenceError: /,
            /webkit-masked-url:/,
            /does not exist for the provided text/,
            /extension:\/\//,
            /\.\/src\/components\//,
            /\/C:\/Users\//,
            /Artfia%20DIY/
        ],
        integrations: [
            new Sentry.BrowserTracing(),
            new CaptureConsoleIntegration(
                {
                    // array of methods that should be captured
                    // defaults to ['log', 'info', 'warn', 'error', 'debug', 'assert']
                    levels: logs
                }
            ),
            new ExtraErrorData({
                // Limit of how deep the object serializer should go. Anything deeper than limit will
                // be replaced with standard Node.js REPL notation of [Object], [Array], [Function] or
                // a primitive value. Defaults to 3.
                depth: 5,
            }),
            new Sentry.Replay()
        ],

        // We recommend adjusting this value in production, or using tracesSampler
        // for finer control
        tracesSampleRate: 0.8,
        replaysOnErrorSampleRate: 0.5,
        replaysSessionSampleRate: 0,
    });
    const sentryReduxEnhancer = Sentry.createReduxEnhancer({
        // Optionally pass options listed below
    });
    enhancers = composeEnhancers(
        applyMiddleware(sagaMiddleware)
        // other store enhancers if any
        , sentryReduxEnhancer
    );
    //enhancers = compose(enhancers, sentryReduxEnhancer);
}

if(document.cookie.split(';').reduce((cookies, cookie) => {
    const [ name, value ] = cookie.split('=').map(c => c.trim());
    if(name==='api_token')
        cookies.push({name, value});
    return cookies;
}, []).length >=2 ){
    const cookies = new Cookies();
    cookies.remove('api_token', {path: '/'});
    if(document.cookie.split(';').reduce((cookies, cookie) => {
        const [ name, value ] = cookie.split('=').map(c => c.trim());
        if(name==='api_token')
            cookies.push({name, value});
        return cookies;
    }, []).length) {
        cookies.remove('api_token', {path: '/', domain:'.artfia.com'});
    }
}

const store = createStore(rootReducer, enhancers);
sagaMiddleware.run(rootSaga);

window.registrationSW = null;
navigator.serviceWorker.getRegistration().then(registration => {
    if (registration) {
        window.registrationSW = registration;
    }
}).finally(() => {
    window.addEventListener('error', event => {
        if (!event || !event.target) {
            return;
        }
        if (event.target.tagName === 'SCRIPT' || event.target.tagName === 'LINK') {
            // Check if the error is related to a failed chunk load
            const chunkFailed = event.target.src.includes('.chunk.') || /\/static\/(css|js)\/\d+\.[a-f0-9]+\.(css|js)^/.test(event.target.src);
            const loadFailed = event.message === 'Load failed';
            if (chunkFailed || loadFailed) {
                // Force the service worker to refresh
                if (loadFailed) {
                    console.error('Load failed', event.target.tagName, event.filename, event.lineno, event.colno, event.error.stack);
                }
                if (window.registrationSW) {
                    window.registrationSW.update().finally(() => {
                        if (window.wb) {
                            window.wb.messageSW({type: 'SKIP_WAITING'});
                        } else {
                            window.registrationSW.active.postMessage({type: 'SKIP_WAITING'});
                        }
                    });
                } else {
                    window.location.reload();
                }
            }
        }
    });
});

ReactDOM.render(
  <Provider store={store}>
    <Project />
  </Provider>,
  document.getElementById('app'));

if ((/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(navigator.userAgent||navigator.vendor||window.opera)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br[ev]w|bumb|bw-[nu]|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do[cp]o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly[-_]|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-[mpt]|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c[- _agpst]|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac[ \-/]|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja[tv]a|jbro|jemu|jigs|kddi|keji|kgt[ /]|klon|kpt |kwc-|kyo[ck]|le(no|xi)|lg( g|\/[klu]|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t[- ov]|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30[02]|n50[025]|n7(0[01]|10)|ne([cm]-|on|tf|wf|wg|wt)|nok[6i]|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan[adt]|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c[-01]|47|mc|nd|ri)|sgh-|shar|sie[-m]|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel[im]|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c[- ]|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test((navigator.userAgent||navigator.vendor||window.opera).substr(0,4)))) {
    window.addEventListener("touchmove", function(event) {
        let target = event.target;
        if (target.id === "app") {
            event.preventDefault();
        }
    });
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

function sendToAnalytics({ id, name, value }) {
    document.addEventListener("readystatechange", function() {
        if (document.readyState === "complete" || window.ga) {
            if (window.ga) {
                window.ga('send', 'event', {
                    eventCategory: 'Web Vitals',
                    eventAction: name,
                    eventValue: Math.round(name === 'CLS' ? value * 1000 : value), // values must be integers
                    eventLabel: id, // id unique to current page load
                    nonInteraction: true, // avoids affecting bounce rate
                });
            } else {
                setTimeout(() => {
                    if (window.ga) {
                        window.ga('send', 'event', {
                            eventCategory: 'Web Vitals',
                            eventAction: name,
                            eventValue: Math.round(name === 'CLS' ? value * 1000 : value), // values must be integers
                            eventLabel: id, // id unique to current page load
                            nonInteraction: true, // avoids affecting bounce rate
                        });
                    }
                }, 600);
            }
            document.removeEventListener("readystatechange", this);
        }
    }, true);

}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(sendToAnalytics);

let isPWAinBrowser = true;
// replace standalone with fullscreen or minimal-ui according to your manifest
if (window.matchMedia && matchMedia('(display-mode: standalone)').matches) {
    // Android and iOS 11.3+
    isPWAinBrowser = false;
} else if ('standalone' in navigator) {
    // useful for iOS < 11.3
    isPWAinBrowser = !navigator.standalone;
}
if (!isPWAinBrowser) {
    console.error('standalone');
}
